import React from 'react';
import { Shield, AlertTriangle, ClipboardCheck, TrendingUp, FileSearch, BarChart3 } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  Shield,
  AlertTriangle,
  ClipboardCheck,
  TrendingUp,
  FileSearch,
  BarChart3
};

const Features = () => {
  return (
    <section id="features" className="py-24 lg:py-32 bg-[var(--bg-section)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[var(--accent-wash)] text-[var(--niko-teal)] text-sm font-medium mb-4">
            Platform Capabilities
          </span>
          <h2 className="heading-2 mb-6">
            Everything You Need for{' '}
            <span className="text-[var(--niko-teal)]">Safer Care</span>
          </h2>
          <p className="body-large">
            One connected platform replacing scattered spreadsheets, disconnected systems, 
            and paper binders with intelligent, real-time safety and quality workflows.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group card hover:border-[var(--niko-teal)]/30 cursor-pointer"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[var(--niko-teal)]/10 to-[var(--niko-green)]/10 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <Icon className="w-6 h-6 text-[var(--niko-teal)]" />
                </div>

                {/* Content */}
                <h3 className="heading-3 mb-3 group-hover:text-[var(--niko-teal)] transition-colors">
                  {feature.title}
                </h3>
                <p className="text-[var(--text-secondary)] leading-relaxed">
                  {feature.description}
                </p>

                {/* Hover Arrow */}
                <div className="mt-5 flex items-center gap-2 text-[var(--niko-teal)] font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-sm">Learn more</span>
                  <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-[var(--text-secondary)] mb-4">
            Built by a nurse, infection preventionist, quality director, and patient safety leader.
          </p>
          <p className="text-sm text-[var(--text-muted)]">
            Every feature designed from real healthcare experience.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;
